module.exports = __webpack_public_path__ + "img/searchbar-black-icon.c7d88677.png";